import template from "./effective-choices-select.html";
import "./effective-choices-select.less";
import "../choices-select/choices-select.less";
import { Controller as ChoicesSelectController } from "../choices-select/choices-select";

export class Controller extends ChoicesSelectController {
	constructor($logger, $scope) {
		super($logger);
		this._scope = $scope;
		this.lastSetChoicesArgs = undefined;
	}

	$onChanges(changes) {
		const effectiveAsOfChanged = changes.effectiveAsOf && !changes.effectiveAsOf.isFirstChange();
		const hasEffectiveRangesChanged = changes.hasEffectiveRanges && !changes.hasEffectiveRanges.isFirstChange();

		if(!this.box || !this.lastSetChoicesArgs || (!effectiveAsOfChanged && !hasEffectiveRangesChanged)) {
			return;
		}

		this._scope.$evalAsync(() => {
			this._scope.$$postDigest(() => {
				this.replayChoices();
			});
		});
	}

	setChoices(choice, valStr, labelStr, boolVal) {
		this.lastSetChoicesArgs = [choice, valStr, labelStr, boolVal];
		return super.setChoices(choice, valStr, labelStr, boolVal);
	}

	clearStore() {
		this.lastSetChoicesArgs = undefined;
		return super.clearStore();
	}

	replayChoices() {
		if(this.box && this.lastSetChoicesArgs) {
			super.setChoices(...this.lastSetChoicesArgs);
		}
	}
}

export default angular
	.module("vesl.components.report-form.effective-choices-select", [])
	.component("effectiveChoicesSelect", {
		template,
		controller: Controller,
		bindings: {
			effectiveAsOf: "<",
			hasEffectiveRanges: "<",
			setDisplay: "&",
			setBox: "&",
			handleValueChanged: "&",
			selectId: "<",
			label: "<",
			search: "<",
			isReadonly: "<",
			selectModel: "="
		}
	}).name;